import { Layout } from "antd";
import MenuLateral from "shared/components/menu-lateral";
import "./Layout.scss";
import { isMobile } from "react-device-detect";

const { Content } = Layout;
const LayoutAutenticado: React.FC<{ children?: React.ReactNode }> = (props) => {
  const { children } = props;

  return (
    <Layout
      className={`layout-customizado  ${isMobile ? "is-mobile" : "is-web"}`}
    >
      <Layout>
        <MenuLateral />
        <Content>{children}</Content>
      </Layout>
    </Layout>
  );
};

export default LayoutAutenticado;
